import React from 'react';
import ReactDOM from 'react-dom/client'; // Altere o import para `createRoot`
import './globals.css';
import { App } from './App';

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement!); // Cria o `root` com a nova API

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
